import { GenericTradeParams } from '@ui/features/Trade/types';
import { usePayTokenPriceLatest } from '@ui/features/Trade/hooks/usePayTokenPriceLatest';
import { useTradePairInfosByPairBase } from '@ui/hooks/trade/useTradePairInfos';
import { ZERO_BIG_NUMBER } from '@ui/lib/bignumber';

import { useGetProperLeverageMargin } from './useGetProperLeverageMargin';

export const useLiqLostP = ({ genericTradeParams }: GenericTradeParams) => {
  const collateralMarketPrice = usePayTokenPriceLatest(
    genericTradeParams.collateralToken,
  );

  const tradePairInfos = useTradePairInfosByPairBase(
    genericTradeParams.pair.address,
  );
  const tradeLeverage = genericTradeParams.getLeverage({
    collateralTokenMarketPrice: collateralMarketPrice ?? ZERO_BIG_NUMBER,
  });

  const properLeverageMargin = useGetProperLeverageMargin(
    tradePairInfos,
    tradeLeverage?.toNumber(),
  );

  return properLeverageMargin?.liqLostP;
};
